import { message, Space } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import ActionBar from "../../../components/action-bar";
import ActionButton from "../../../components/action-button";
import MiniTable from "../../../components/mini-table";
import { Alerta } from "../../../constants";
import useDispatchWithResult from "../../../hooks/useDispatchWithResult";
import useLoading from "../../../hooks/useLoading";
import {
  fetchTributarios,
  fetchVerificarLimite,
  isEditableSelector,
  tributariosAlertaNivelSelector,
  tributariosAlertasSelector,
  tributariosSearchSelector,
  tributariosSelector,
} from "../../../store/empresa";
import unwrapAxiosPromise from "../../../util/unwrapAxiosPromise";
import { openPopup } from "../../../util/window";
import Alertas from "../_Alertas";
import styles from "../_styles.less";
import EmpresaTributariosTable from "./_table";
import useModulo from "../../../hooks/useModulo";

export default function EmpresaTributariosDetailPage() {
  const miniTableRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatchWithResult();
  const nivel = useSelector(tributariosAlertaNivelSelector);
  const isEditable = useSelector(isEditableSelector);
  const tributarios = useSelector(tributariosSelector);
  const search = useSelector(tributariosSearchSelector);
  const alertas = useSelector(tributariosAlertasSelector);
  const loading = useLoading(fetchTributarios.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const empresaId = match.params.empresaId;
  const { moduloBasePath } = useModulo();
  const [loadingCopy, setLoadingCopy] = useState(false);
  const [loadingRemove, setLoadingRemove] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const isNA =
    nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleSearch = (search) => {
    dispatch(fetchTributarios({ empresaId, search }));
  };

  const handleCreate = () => {
     unwrapAxiosPromise(dispatch(fetchVerificarLimite()))
            .then(() => {
              history.replace(
      `${moduloBasePath}/empresas/${empresaId}/tributarios/create`);
            })
  };

  const handleCopy = () => {
    setLoadingCopy(true);
    unwrapAxiosPromise(
      axios.get(`/empresas/${empresaId}/tributarios/${selectedIds[0]}`)
    )
      .then((data) => {
        history.replace({
          pathname: `${moduloBasePath}/empresas/${empresaId}/tributarios/create`,
          state: { data },
        });
      })
      .finally(() => setLoadingCopy(false));
  };

  const handleRemove = () => {
    setLoadingRemove(true);
    unwrapAxiosPromise(
      axios.delete(`/empresas/${empresaId}/tributarios`, {
        params: { ids: selectedIds },
      })
    )
      .then(() => {
        message.success(t("Registro(s) removido(s) com sucesso"));
        setSelectedIds([]);
        dispatch(fetchTributarios({ empresaId }));
      })
      .finally(() => setLoadingRemove(false));
  };

  const handleDetail = (tributario) => {
    history.replace(
      `${moduloBasePath}/empresas/${empresaId}/tributarios/${tributario.id}`
    );
  };

  const handleLogs = () => {
    openPopup(
      `/logs?categoria=/empresas/${empresaId}/tributarios/`,
      `logs_/empresas/${empresaId}/tributarios/`
    );
  };

  const actions = [];
  if (isEditable) {
    actions.push(
      <ActionButton.Create disabled={isNA} onClick={handleCreate} />
    );
    actions.push(
      <ActionButton.CreateCopy
        disabled={selectedIds.length !== 1 || isNA}
        onClick={handleCopy}
        loading={loadingCopy}
      />
    );
    actions.push(
      <ActionButton.Remove
        disabled={selectedIds.length === 0 || isNA}
        onClick={handleRemove}
        loading={loadingRemove}
      />
    );
  }
  actions.push(<ActionButton.Logs noTitle onClick={handleLogs} />);
  actions.push(
    <MiniTable.DownloadButton
      disabled={loading || tributarios.length === 0}
      miniTableRef={miniTableRef}
    />
  );
  const title = () => (
    <ActionBar search={search} onSearch={handleSearch}>
      {actions}
    </ActionBar>
  );
  return (
    <Space direction="vertical" className={styles["space-2"]}>
      <EmpresaTributariosTable
        dataSource={tributarios}
        loading={loading}
        miniTableRef={miniTableRef}
        onClick={handleDetail}
        onSelectedIdsChange={setSelectedIds}
        selectedIds={selectedIds}
        title={title}
      />
      <Alertas alertas={alertas} />
    </Space>
  );
}

EmpresaTributariosDetailPage.propTypes = {
  tributarios: PropTypes.array,
  onCreate: PropTypes.func,
  onRemove: PropTypes.func,
};
